import React from "react";
import { motion } from "framer-motion";
import { Quote, Star, ArrowUpRight } from "lucide-react";
import "./Testimonials.css";

const REVIEWS_URL = "https://share.google/hrZwBCBfl0PfMDcx1";

/* Placeholder testimonials — replace with live data via Google Places API.
   Implementation note for dev:
     - Set VITE_GOOGLE_PLACES_API_KEY and VITE_GOOGLE_PLACE_ID env vars.
     - Fetch reviews from https://places.googleapis.com/v1/places/{placeId}?fields=reviews
     - Cache server-side (24h) to stay under free-tier limits. */
const TESTIMONIALS = [
  {
    rating: 5,
    quote:
      "Three crews from Adel over two years. They don't just send names—they send people ready to work. Our projects run on time because Adel's standard is our standard.",
    name: "Khalid M.",
    role: "Operations Manager",
    location: "Logistics · UAE",
    industry: "Logistics & Warehousing",
  },
  {
    rating: 5,
    quote:
      "When I got the Saudi offer, I was anxious about paperwork, visas, being far from home. Adel walked me through everything. Six months in and I'm stable—that support made the difference.",
    name: "Grace K.",
    role: "Housekeeping Supervisor",
    location: "Hospitality · KSA",
    industry: "Hospitality & Catering",
  },
  {
    rating: 5,
    quote:
      "In recruitment, shortcuts are easy—reliability is hard. Adel chose reliability. Our facilities team in Qatar has been stable for 18 months because every person came through their process.",
    name: "Ahmed H.",
    role: "Facilities Director",
    location: "FM · Qatar",
    industry: "Facilities Management",
  },
];

function Stars({ count }) {
  return (
    <span className="testi__stars" aria-label={`${count} out of 5 stars`}>
      {Array.from({ length: 5 }).map((_, i) => (
        <Star
          key={i}
          size={14}
          strokeWidth={0}
          fill={i < count ? "var(--accent)" : "rgba(245,241,234,0.18)"}
        />
      ))}
    </span>
  );
}

export default function Testimonials() {
  return (
    <section className="testi">
      <div className="container">
        <div className="testi__header">
          <div>
            <span className="eyebrow">What they say</span>
            <h2 className="testi__title">
              Stories from{" "}
              <span className="testi__title-accent">both sides.</span>
            </h2>
            <p className="testi__intro">
              Reviews from Middle East employers and placed Kenyan
              candidates—shared on Google. Live integration coming soon.
            </p>
          </div>
          <a
            href={REVIEWS_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="testi__see-all"
            data-cursor="cta"
          >
            View on Google
            <ArrowUpRight size={16} strokeWidth={2} />
          </a>
        </div>

        <div className="testi__grid">
          {TESTIMONIALS.map((t, i) => (
            <motion.article
              key={t.name + i}
              className="testi__card"
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{
                duration: 0.6,
                delay: i * 0.08,
                ease: [0.22, 1, 0.36, 1],
              }}
              data-cursor="card"
            >
              <span className="testi__source" title="Sourced from Google reviews">
                Google · Placeholder
              </span>
              <Quote className="testi__quote-mark" size={32} strokeWidth={1} />
              <Stars count={t.rating} />
              <p className="testi__quote">&ldquo;{t.quote}&rdquo;</p>
              <footer className="testi__footer">
                <div className="testi__attr">
                  <span className="testi__name">{t.name}</span>
                  <span className="testi__role">{t.role}</span>
                </div>
                <span className="testi__tag">{t.industry}</span>
              </footer>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
